import {
  AuthenticationGuard,
  WithKetch,
} from "@inductiveautomation/ws-components";
import { createBrowserRouter, Navigate, redirect } from "react-router";
import Callback from "./routes/Callback/Callback.tsx";
import EmailPreferencesAuth from "./routes/EmailPreferences/EmailPreferencesAuth/EmailPreferencesAuth.tsx";
import Error from "./routes/Error/Error.tsx";
import NotFound from "./routes/Error/NotFound.tsx";
import License from "./routes/Licenses/License/License.tsx";
import Details from "./routes/Licenses/License/tabs/Details.tsx";
import Modules from "./routes/Licenses/License/tabs/Modules.tsx";
import Sessions from "./routes/Licenses/License/tabs/Sessions.tsx";
import Activations from "./routes/Licenses/License/tabs/Activations.tsx";
import Licenses from "./routes/Licenses/Licenses.tsx";
import Organizations from "./routes/Organizations/Organizations.tsx";
import AdditionalEmailVerification from "./routes/Profile/confirmation/AdditionalEmailVerification.tsx";
import DeleteAccountConfirmation from "./routes/Profile/confirmation/DeleteAccountConfirmation.tsx";
import PrimaryEmailConfirmation from "./routes/Profile/confirmation/PrimaryEmailConfirmation.tsx";
import Profile from "./routes/Profile/Profile.tsx";
import PublicProfile from "./routes/PublicProfile/PublicProfile.tsx";
import Root from "./routes/Root/Root.tsx";
import Subscription from "./routes/Subscription/Subscription.tsx";
import Training from "./routes/Training/Training.tsx";

const router = createBrowserRouter(
  [
    {
      path: "/callback",
      element: (
        <AuthenticationGuard
          component={Callback}
          baseAssetUrl={window._acctConfig?.BASE_ASSET_URL ?? ""}
        />
      ),
    },
    {
      path: "/login",
      errorElement: <Error />,
      element: <Navigate to={"/"} />,
    },
    {
      path: "subscription",
      errorElement: <Error />,
      element: <Subscription />,
    },
    {
      path: "/",
      errorElement: <Error />,
      element: (
        <AuthenticationGuard
          component={() => (
            <WithKetch>
              <Root />
            </WithKetch>
          )}
          baseAssetUrl={window._acctConfig?.BASE_ASSET_URL ?? ""}
        />
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/profile" replace />,
        },
        {
          path: "profile",
          element: <Profile />,
        },
        {
          path: "email-preferences-na",
          element: <Navigate to="/email-preferences" replace />,
        },
        {
          path: "email-preferences-auth",
          element: <Navigate to="/email-preferences" replace />,
        },
        {
          path: "email-preferences",
          element: <EmailPreferencesAuth />,
        },
        {
          path: "organizations",
          element: <Organizations />,
        },
        {
          path: "maker-licenses",
          element: <Licenses />,
        },
        {
          path: "maker-licenses/:id",
          element: <License />,
          loader: ({ params }) => {
            if (!params.id) {
              return redirect("/maker-licenses");
            }
            return null;
          },
          children: [
            {
              index: true,
              element: <Details />,
            },
            {
              path: "modules",
              element: <Modules />,
            },
            {
              path: "activations",
              element: <Activations />,
            },
            {
              path: "sessions",
              element: <Sessions />,
            },
          ],
        },
        {
          path: "training",
          element: <Training />,
        },
      ],
    },
    {
      path: "confirm",
      errorElement: <Error />,
      children: [
        {
          path: "primary-email",
          element: (
            <WithKetch>
              <PrimaryEmailConfirmation />
            </WithKetch>
          ),
        },
        {
          path: "additional-email",
          element: <Navigate to={"/"} />,
        },
        {
          path: "delete-account",
          element: (
            <WithKetch>
              <DeleteAccountConfirmation />
            </WithKetch>
          ),
        },
      ],
    },
    {
      path: "additionalEmails/verify",
      errorElement: <Error />,
      element: (
        <AuthenticationGuard
          component={AdditionalEmailVerification}
          baseAssetUrl={window._acctConfig?.BASE_ASSET_URL ?? ""}
        />
      ),
    },
    {
      path: ":profileUrl",
      errorElement: <Error />,
      element: <PublicProfile />,
    },
    {
      path: "404",
      element: (
        <WithKetch>
          <NotFound />
        </WithKetch>
      ),
    },
  ],
  {
    basename: import.meta.env.BASE_URL,
  }
);

export default router;
